/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Icon, message} from 'antd'
// import {DateTimePicker} from "react-advance-jalaali-datepicker";
import Select from 'react-select'

import moment from 'moment'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import AutoComplete from '../BaseComponent/autocomplete'

import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'

const Option = Select.Option

class OrderStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      selectedDate: null,
      location: [],
      orderStatus: [],
      selectBoxText: '',
      providers: [],
      today: moment(),
      input_supplierName: '',
      selectedOption: [],
      providerId: ''
    }
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] ='' + result[i].providerId + ' - ' + result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERDELIVERYLOCATION_LIST}`, {})
      .then((response) => {
        if (response.data.error == null && !(response.data.object == null)) {
          this.setState({
            location: response.data.object
          })
        } else if (response.data.error == null && response.data.object == null) {
          message.warning('در جدول پایه "محل تحویل" مقدار دهی اولیه انجام نشده است', 5)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_LIST}`, {})
      .then((response) => {
        if (response.data.error == null && !(response.data.object == null)) {
          console.log(response.data.object)
          this.setState({
            orderStatus: response.data.object.filter(
              (item) => item.orderStatusId === 1 || item.orderStatusId === 2 || item.orderStatusId === 3
            )
          })
        } else if (response.data.error == null && response.data.object == null) {
          message.warning('در جدول پایه "وضعیت" مقدار دهی اولیه انجام نشده است', 5)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  submit() {
    let supplierId = this.state.providerId
    let input_initialDeliveryTimeStamp = document.getElementById('input_initialDeliveryTimeStamp').value
    let input_orderDeliveryLocationId = document.getElementById('input_orderDeliveryLocationId').value
    let input_visitorName = document.getElementById('input_visitorName').value
    let input_visitorPhone = this.convertDigit(document.getElementById('input_visitorPhone').value)
    let input_orderStatusId = document.getElementById('input_orderStatusId').value
    let input_comment = document.getElementById('input_comment').value
    let hour = document.getElementById('hour').value
    let min = document.getElementById('min').value

    let formError = false
    let supError = false
    let timeError = false
    let locError = false
    var mobileError = false
    let statusError = false
    let cmError = false
    let hourError = false
    let minError = false

    if (supplierId == '') {
      formError = true
      supError = true
      message.error('نام تامین کننده را وارد کنید')
    } else {
      if (!supError) {
        this.setState({
          error: ''
        })
      }
    }

    if (hour == '' || min == '') {
      formError = true
      hourError = true
      minError = true
      message.error('ساعت را وارد کنید')
    }
    if (hour > 24 || hour < 0) {
      formError = true
      hourError = true
      message.error('ساعت حداکثر 24 ساعت است و حداقل آن 00')
    }
    if (min > 60 || min < 0) {
      formError = true
      minError = true
      message.error('دقیقه حداکثر 60 است و حداقل آن 00')
    } else {
      if (!hourError && !minError) {
        this.setState({
          error: ''
        })
      }
    }

    if (input_initialDeliveryTimeStamp == '') {
      formError = true
      timeError = true
      message.error('تاریخ مقرر را تعریف کنید')
    } else {
      if (!timeError) {
        this.setState({
          error: ''
        })
      }
    }

    if (input_orderDeliveryLocationId == '') {
      formError = true
      locError = true
      message.error('محل تحویل را مشخص کنید')
    } else {
      if (!locError) {
        this.setState({
          error: ''
        })
      }
    }
    if (input_orderStatusId == '') {
      formError = true
      statusError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!statusError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!(input_visitorPhone == '') && !input_visitorPhone.match(/^09\d{9}$/g)) {
      mobileError = true
      formError = true
      message.error('موبایل را صحیح وارد کنید.مثال : 09124444444')
    } else {
      if (!mobileError) {
        this.setState({error: ''})
      }
    }
    if (input_comment.length > 10000) {
      formError = true
      cmError = true
      message.error('طول توضیحات بسیار زیاد است')
    } else {
      if (!cmError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      const token = sessionStorage.getItem('accessToken')
      const data = {
        supplierId,
        initialDeliveryTime: this.epochFrom(this.convertDigit(input_initialDeliveryTimeStamp + hour + ':' + min)),
        deliveryLocationId: input_orderDeliveryLocationId,
        visitorName: input_visitorName == '' ? undefined : input_visitorName,
        phoneNumber: input_visitorPhone == '' ? undefined : input_visitorPhone,
        orderStatusId: input_orderStatusId,
        orderComment: input_comment == '' ? undefined : input_comment
      }

      http
        .post(`${ORDER_STATUS.ORDERS_STATUS_ORDER_ADD}`, data, {})
        .then((response) => {
          // alert(JSON.stringify(response.data))
          if (response.data.error == null && response.data.object == 'SUCCESS') {
            message.success('سفارش مورد نظر ثبت شد.لطفا صبر کنید')
            setInterval(() => {
              window.location.assign('/orderList')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  epochFrom = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = (concatDayMount[1] + concatDayMount[2]).substr(0, 4)
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)
    let miladiDate = jMoment(x, 'jYYYY/jM/jD HH:mm').format('YYYY/M/D HH:mm')
    let from = miladiDate
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  Date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (date) => {
    this.setState({selectedDate: date})
  }

  submitData(e) {
    e.preventDefault()
  }

  changeSelect(value) {
    this.setState({
      input_supplierName: value
    })
  }
  render() {
    const {selectedDate, selectedOption} = this.state

    return (
      <div className="rtl printA4Page">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>سفارشات</li>
            <li>افزودن سفارش</li>
          </ul>

          <form className={'verticalForm w-75'} onSubmit={this.submitData.bind(this)}>
            <div className="headerVertical">
              <p>افزودن سفارش</p>
            </div>
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className="formComponent selectComponent">
                    <AutoComplete
                      label="تامین کننده"
                      api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                      textField="title"
                      valueField="providerId"
                      id="provider"
                      value={this.state.providerId}
                      required
                      setValue={(providerId) => this.setState({providerId})}
                    />
                    {/* <label>تامین کننده <span className='requireFiled'>*</span></label>
                                        <Select
                                            value={selectedOption}
                                            onChange={this.handleChange}
                                            options={this.state.providers}
                                            isMulti={false}
                                            isClearable={true}
                                            placeholder={''}
                                            id="input_supplierName"
                                            name="input_supplierName"
                                            tabIndex='1'
                                        /> */}
                  </div>
                  <div className="formComponent">
                    <label>
                      ساعت تحویل <span className="requireFiled">*</span>
                    </label>

                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start'
                      }}
                    >
                      <input
                        tabIndex="4"
                        maxLength={2}
                        id="min"
                        placeholder="دقیقه"
                        className="form-control"
                        type="text"
                        style={{
                          width: '60px',
                          textAlign: 'center',
                          fontSize: '1em'
                        }}
                      />
                      <p style={{marginRight: '20px', fontSize: '2em'}}>:</p>
                      <input
                        tabIndex="3"
                        maxLength={2}
                        placeholder="ساعت"
                        id="hour"
                        className="form-control"
                        type="text"
                        style={{
                          width: '60px',
                          textAlign: 'center',
                          fontSize: '1em',
                          marginRight: '20px'
                        }}
                      />
                    </div>
                  </div>
                  <div className="formComponent">
                    <label>نام ویزیتور</label>
                    <input
                      tabIndex="6"
                      type={'text'}
                      className={'form-control'}
                      name="input_visitorName"
                      id="input_visitorName"
                    />
                  </div>
                  <div className="formComponent">
                    <label>
                      وضعیت <span className="requireFiled">*</span>
                    </label>
                    <select tabIndex="8" className={'form-control'} name="input_orderStatusId" id="input_orderStatusId">
                      <option value="">-------</option>
                      {this.state.orderStatus.map((orderStatus, index) => (
                        <option key={index} value={orderStatus.orderStatusId}>
                          {orderStatus.orderStatusName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-6">
                  <div className="formComponent">
                    <label>
                      تاریخ مقرر <span className="requireFiled">*</span>
                    </label>

                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        okLabel="تأیید"
                        autoOk={true}
                        leftArrowIcon={<Icon type="left" />}
                        rightArrowIcon={<Icon type="right" />}
                        cancelLabel="لغو"
                        labelFunc={(selectedDate) => (selectedDate == null ? '' : selectedDate.format('jYYYY/jMM/jDD'))}
                        value={selectedDate}
                        id="input_initialDeliveryTimeStamp"
                        ref={(node) => (this.planDate = node)}
                        onChange={this.handleDateChange}
                        TextFieldComponent={this.Date}
                        tabIndex="2"
                        readOnly
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className="formComponent">
                    <label>
                      محل تحویل <span className="requireFiled">*</span>
                    </label>
                    <select
                      tabIndex="5"
                      className="form-control"
                      id="input_orderDeliveryLocationId"
                      name="input_orderDeliveryLocationId"
                    >
                      <option value={''}>-------</option>

                      {this.state.location.map((loc, index) => (
                        <option key={index} value={loc.deliveryLocationId}>
                          {loc.deliveryLocationName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="formComponent">
                    <label>شماره همراه ویزیتور</label>
                    <input
                      tabIndex="7"
                      type={'text'}
                      className={'form-control'}
                      id="input_visitorPhone"
                      name="input_visitorPhone"
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="formComponent">
                    <label>توضیحات</label>
                    <textarea
                      tabIndex="9"
                      className={'form-control'}
                      style={{minHeight: '200px'}}
                      name="input_comment"
                      id="input_comment"
                    />

                    <button className={'btn btn-info btn-block'} onClick={this.submit.bind(this)}>
                      افزودن
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default OrderStatus
